export const uk = {
    'many-platforms-count': '{selectedCount} экранов из {totalCount}',
    'many-screens-count': '{selectedCount} экранов',
    'nothing-found': 'Ничего не найдено',
    'one-platforms-count': '{selectedCount} экран из {totalCount}',
    'one-screens-count': '{selectedCount} экран',
    'some-platforms-count': '{selectedCount} экрана из {totalCount}',
    'some-screens-count': '{selectedCount} экрана'
};
